<template>
  <v-card>
    <v-progress-linear
      class="mt-2 mb-0"
      :color="getColor(task.status)"
      :height="task.status === 'in_progress' ? 20 : 22"
      :value="
        task.status === 'in_progress'
          ? task.processing_state && task.processing_state.value
            ? task.processing_state.value
            : 0
          : 100
      "
      striped
    >
      <template v-slot="{}">
        <strong v-if="task.status === 'todo'" class="white--text">
          Waiting for execution
        </strong>
        <strong
          v-if="task.status === 'in_progress' && task.processing_state"
          class="white--text"
        >
          {{ task.processing_state.label || 'Task in progress' }}
        </strong>
        <strong v-else-if="task.status === 'failed'" class="white--text">
          Failed
        </strong>
        <strong v-else-if="task.status === 'completed'" class="white--text">
          Completed
        </strong>
      </template>
    </v-progress-linear>
    <v-progress-linear
      v-if="task.status === 'in_progress'"
      class="mb-2"
      color="primary"
      height="2"
      indeterminate
    />
    <v-row dense class="mt-2">
      <v-col xs="6" sm="4" md="4">
        <file-statistics :stats="statistics" />
      </v-col>
      <v-col xs="6" sm="8" md="8" class="d-flex flex-column">
        <FileStatusesFilters
          hide-errors
          ref="fileStatusesFilters"
          :errors="errors"
          :rowStatuses="rowStatuses"
          :role="role"
          @onChange="handleFiltersChange"
        />
        <v-row dense class="pr-4 flex-grow-0 mt-auto">
          <v-spacer />
          <v-scroll-x-transition>
            <v-text-field
              v-if="searchEnabled"
              class="pa-0 ma-0"
              v-model="filters.search"
              autofocus
              label="Search by original name"
              single-line
              hide-details
            />
          </v-scroll-x-transition>
          <v-tooltip bottom color="white">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                color="primary"
                @click="() => (searchEnabled = !searchEnabled)"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <span class="black&#45;&#45;text">Click to enable search.</span>
          </v-tooltip>

          <FileFilters
            hide-show-price-details-toggle
            hide-reviewed-toggle
            ref="fileFilters"
            @onChange="handleFiltersChange"
          />

          <FileReportsMenu active-customer-view :result="result" />
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import FileStatistics from './FileStatistics';
import FileStatusesFilters from './FileStatusesFilters';
import FileFilters from '@/components/files/FileFilters';
import { DEFAULTS } from '@/constants';
import moment from 'moment';
import * as _ from 'lodash';
import { GlobalConfig } from '@/shared/GlobalAppconfig.class';
import FileReportsMenu from '@/components/files/FileReportsMenu';

export default {
  props: {
    role: {
      type: String,
      default: ''
    },
    errors: {
      type: Array,
      default: () => []
    },
    rowStatuses: {
      type: Array,
      default: () => []
    },
    task: {
      type: Object,
      default: () => ({})
    },
    statistics: {
      type: Object,
      default: () => ({})
    },
    result: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    rowStatusesComputed() {
      if (!this.rowStatuses?.length) return [];

      return DEFAULTS.SHOW_STATUSES.customer.map((name) => {
        const status = _.find(this.rowStatuses, { name });

        return {
          ...status,
          icon: this.getStatusByName(name).icon,
          color: this.getStatusByName(name).color
        };
      });
    }
  },
  data: () => ({
    selectedFilters: [],
    searchEnabled: false,
    selectedVersion: 0,
    filters: {
      search: '',
      statuses: [],
      multimatch: false,
      excludeIgnore: false,
      showPrice: true,
      reviewed: false,
      customerVerified: false
    }
  }),
  created() {
    GlobalConfig.config.notLatestVersion = false;
    this.selectedVersion = this.$route.params.result_id;
  },
  watch: {
    filters: {
      deep: true,
      handler(newValue) {
        clearTimeout(this.searchTimeout);

        this.searchTimeout = setTimeout(() => {
          this.$emit('onFiltersChanged', newValue);
        }, 300);
      }
    },
    result(value) {
      this.enterpriseSessionId = value.task.rhapsody_enterprise_session_id;
    }
  },
  components: {
    FileStatistics,
    FileStatusesFilters,
    FileReportsMenu,
    FileFilters
  },
  methods: {
    getColor(status) {
      switch (status) {
        case 'completed':
          return 'success';
        case 'failed':
          return 'error';
        case 'in_progress':
          return 'primary';
        case 'todo':
          return 'accent';
      }
    },
    formatDate(dateString) {
      return moment(dateString).format('MM.DD-HH:mm');
    },
    selectVersion(version) {
      this.selectedVersion = version.id;
      this.$router.push({
        name: 'EditFile',
        params: {
          result_id: this.selectedVersion
        }
      });
    },
    resetMultimatch() {
      this.$refs.fileFilters.resetMultimatch();
    },
    getStatusByName(statusName) {
      const status = DEFAULTS.ROWS_STATUSES[statusName];
      if (status) return status;
      else {
        return DEFAULTS.ROWS_STATUSES.not_reviewed;
      }
    },
    handleFiltersChange({ filter, value }) {
      this.filters[filter] = value;
    }
  }
};
</script>
